<!--
 * @Descripttion: 
 * @Author: voanit
 * @Date: 2021-08-17 20:29:38
 * @LastEditors: voanit
 * @LastEditTime: 2022-01-25 15:37:49
-->
<template>
  <div class="data-page">
    <tooltipLine
      :tip="$store.state.language === 'en' ? require('@/assets/images/ad-en.png') : require('@/assets/images/ad.png')"
      :visible="
        !($store.state.user.hasBindData && $store.state.user.hasBindData.isExistAds) &&
        $store.state.user.sourceType !== 2
      "
      :content="$t('ad-analysis::auth_tooltip')"
    >
      <span slot="btn">
        <!-- <span class="bind-btn" @click="onSetAd">{{ $t('user-guidance::guide::adAccount_text') }}</span> -->
        <span class="bind-btn" @click="onSetAd('fb')">{{ $t('ad-analysis::auth_fb') }}</span>
        <span class="bind-btn" @click="onSetAd('google')">{{ $t('ad-analysis::auth_google') }}</span>
      </span>
    </tooltipLine>

    <el-row type="flex" justify="space-between">
      <el-col :xl="10" :lg="10" :md="10" :sm="10" :xs="10">
        <el-button :type="params.adSource === 0 ? 'primary' : ''" @click="changeSource(0)">
          {{ $t('ad-analysis::tab_all') }}
        </el-button>
        <el-button :type="params.adSource === 1 ? 'primary' : ''" @click="changeSource(1)">Facebook</el-button>
        <el-button :type="params.adSource === 2 ? 'primary' : ''" @click="changeSource(2)">Google</el-button>
      </el-col>
      <el-col :xl="14" :lg="14" :md="14" :sm="14" :xs="14" class="right-content">
        <z-select
          v-model="params.brandId"
          filterable
          :placeholder="$t('ad-analysis::placeholder_shop')"
          :options="shopList"
          :popperAppendToBody="false"
          style="margin-right: 20px; width: 180px"
          @change="reset"
        ></z-select>
        <span style="width: 50px">{{ $t('ad-analysis::date') }}：</span>
        <el-date-picker
          style="width: 265px"
          :appendToBody="false"
          :clearable="false"
          v-model="date"
          type="daterange"
          align="right"
          unlink-panels
          :range-separator="$t('system::time::text::include')"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions"
          @change="handlerDateChange"
        ></el-date-picker>
        <el-select v-model="params.click_value" v-show="params.adSource !== 2" class="select-item" @change="getAllData">
          <el-option label="1 Click" value="one_day_click"></el-option>
          <el-option label="7 Click" value="seven_day_click"></el-option>
        </el-select>
        <el-select
          v-model="params.view_value"
          v-show="params.adSource !== 2"
          class="select-item"
          style="margin-left: 0"
          @change="getAllData"
        >
          <el-option label="1 View" value="one_day_view"></el-option>
          <!-- <el-option label="7 View" value="seven_day_view"></el-option> -->
        </el-select>
      </el-col>
    </el-row>
    <div style="display: flex; align-items: center">
      <el-row type="flex" justify="space-between" :gutter="20" style="flex: 1">
        <el-col v-for="(item, index) in cardOptions" :key="index">
          <dataCard class="ad-anaylsis-card" active="" :option="item" v-loading="loading"></dataCard>
        </el-col>
      </el-row>
      <el-card style="margin-left: 20px; margin-top: 10px">
        <div @click="ruleSetting" class="setting">
          <i class="iconfont icona-15shezhi" style="font-size: 24px; color: #999"></i>
          <div style="margin-top: 8px; font-size: 12px; color: #999">{{ $t('system::rbac::设置') }}</div>
        </div>
      </el-card>
    </div>
    <el-row :gutter="20" v-show="params.adSource === 0">
      <el-col :lg="8" :md="24" :sm="24" :xl="8">
        <reportCard
          :config="adCostTop"
          v-loading="loadingSale.adCostTop"
          :style="`height: ${reportHeight};`"
        ></reportCard>
      </el-col>
      <el-col :lg="8" :md="24" :sm="24" :xl="8">
        <reportCard
          :config="payamountTop"
          v-loading="loadingSale.payamountTop"
          :style="`height: ${reportHeight};`"
        ></reportCard>
      </el-col>
      <el-col :lg="8" :md="24" :sm="24" :xl="8">
        <reportCard :config="roiTop" v-loading="loadingSale.roiTop" :style="`height: ${reportHeight};`"></reportCard>
      </el-col>
    </el-row>
    <el-row :gutter="20" v-show="params.adSource === 0">
      <el-col :lg="12" :md="24" :sm="24" :xl="12">
        <reportTable
          :config="campaignTop"
          v-loading="loadingSale.campaignTop"
          :style="`height: ${reportHeight};`"
          @change="getCampaignTop"
        >
          <el-table-column
            :label="$t('ad-analysis::广告系列名称')"
            :show-overflow-tooltip="true"
            min-width="100"
            prop="campaignName"
          ></el-table-column>
          <el-table-column prop="adSpend" :label="$t('ad-analysis::cost_title')">
            <template slot-scope="scope">
              {{ $dataCheck(formatNumberMix(scope.row.adSpend, 2, ''), '--') }}
            </template>
          </el-table-column>
          <el-table-column prop="payAmount" :label="$t('ad-analysis::成交额')">
            <template slot-scope="scope">
              {{ $dataCheck(formatNumberMix(scope.row.payAmount, 2, ''), '--') }}
            </template>
          </el-table-column>
          <el-table-column
            prop="roi"
            label="ROI"
            :formatter="row => `${row.roi ? formatNumberMix(row.roi, 2, '') : '--'}`"
          ></el-table-column>
        </reportTable>
      </el-col>
      <el-col :lg="12" :md="24" :sm="24" :xl="12">
        <reportCard
          :config="salesEcharts"
          v-loading="loadingSale.salesEcharts"
          :style="`height: ${reportHeight};`"
        ></reportCard>
      </el-col>
    </el-row>
    <el-row :gutter="20" v-show="params.adSource === 1">
      <el-col :lg="12" :md="24" :sm="24" :xl="12">
        <reportCard
          class="trend-card"
          :config="trendData"
          v-loading="loadingSale.trendData"
          :style="`height: ${reportHeight};`"
        >
          <template slot="other">
            <div class="select-group">
              <el-select v-model="measure1" class="select-type" @change="getTrendData">
                <el-option
                  v-for="item in trendOptions"
                  :key="item.value"
                  :disabled="measure2 === item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
              VS
              <el-select v-model="measure2" class="select-type" @change="getTrendData">
                <el-option
                  v-for="item in trendOptions"
                  :key="item.value"
                  :disabled="measure1 === item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
          </template>
        </reportCard>
      </el-col>

      <el-col :lg="12" :md="24" :sm="24" :xl="12">
        <reportCard
          :config="adTransData"
          v-loading="loadingSale.adTransData"
          :style="`height: ${reportHeight};`"
        ></reportCard>
      </el-col>
    </el-row>
    <el-card :body-style="{ padding: '16px' }" style="margin: 16px 0">
      <div class="table-search">
        <div style="display: flex; align-items: center">
          <z-select
            v-model="form.adAccountId"
            filterable
            clearable
            :placeholder="$t('ad-analysis::placeholder_account')"
            :options="accounts"
            :popper-append-to-body="false"
            :disabled="currentType > 1"
            @change="getAdsTableData"
            style="margin-right: 20px"
          ></z-select>
          <div class="effect--split">
            <span v-if="currentType > 1">
              {{ $t('ad-analysis::adAccount') }}：
              <a @click="clickTableSeries(currentRow, 1)">{{ currentRow.adAccountName }}</a>
            </span>
            <span v-if="currentType > 2">
              >> {{ $t('ad-analysis::adSeries') }}：
              <a @click="clickTableSeries(currentRow, 2)">{{ currentRow.adCampaignName }}</a>
            </span>
            <span v-if="currentType > 3">
              >> {{ $t('ad-analysis::adGroup') }}：
              <a @click="clickTableSeries(currentRow, 3)">{{ currentRow.adAdsetName }}</a>
            </span>
          </div>
        </div>
        <el-button icon="el-icon-edit" @click="handleTableHeader">
          {{ $t('system::common::editorHeader-table::btn') }}
        </el-button>
      </div>
      <editor-header-table
        ref="editorTable"
        v-loading="TableLoading"
        :data="tableDataList"
        :pagination.sync="pagination"
        :table-name="tableName"
        :fixTableHeaderList="fixTableHeaderList"
        :columns="columns"
        :defaultColumns="columns"
        :maxHeight="350"
        @page-change="getAdsTableData"
      >
        <template #date="{ row }">
          <span>{{ $dataCheck(row.date) }}</span>
        </template>
        <template #adAccountName="{ row }">
          <!-- row.sourceType fb是0 , Google是1  -->
          <a
            @click="clickTableSeries(row)"
            v-if="sourceType == 2 ? (row.sourceType == '0' ? currentType < 4 : currentType < 2) : currentType < 4"
          >
            {{ getTableSeries(row, currentType) }}
          </a>
          <span v-else>{{ getTableSeries(row, currentType) }}</span>
        </template>
        <template #tableSeriesHeader>
          <div>{{ getTableHeader() }}</div>
        </template>
        <template #shopName="{ row }">
          <span>{{ $dataCheck(row.shopName) }}</span>
        </template>
        <template #adName="{ row }">
          <span>{{ $dataCheck(row.adName) }}</span>
        </template>
        <template #saleAmount="{ row }">
          <span>${{ $dataCheck(formatNumberMix(row.saleAmount, 2, ','), '0') }}</span>
        </template>
        <template #adSpend="{ row }">
          <span>${{ $dataCheck(formatNumberMix(row.adSpend, 2, ','), '0') }}</span>
        </template>
        <template #roi="{ row }">
          <span>{{ $dataCheck(row.roi) }}</span>
        </template>
        <template #coverCnt="{ row }">
          <span>{{ $dataCheck(row.coverCnt) }}</span>
        </template>
        <template #clickCnt="{ row }">
          <span>{{ $dataCheck(row.clickCnt) }}</span>
        </template>
        <template #clickRate="{ row }">
          <span>{{ $dataCheck(formatNumberMix(row.clickRate, 2, ','), '0') }}%</span>
        </template>
        <template #payTransRate="{ row }">
          <span>{{ $dataCheck(formatNumberMix(row.payTransRate, 2, ','), '0') }}%</span>
        </template>
        <template #transFeePer="{ row }">
          <span>${{ $dataCheck(formatNumberMix(row.transFeePer, 2, ','), '0') }}</span>
        </template>
        <template #customerPrice="{ row }">
          <span>${{ $dataCheck(formatNumberMix(row.customerPrice, 2, ','), '0') }}</span>
        </template>
        <template #addToCart="{ row }">
          <span>{{ $dataCheck(row.addToCart) }}</span>
        </template>
        <template #costPerCart="{ row }">
          <span>${{ $dataCheck(row.costPerCart, '0') }}</span>
        </template>
        <template #paymentCnt="{ row }">
          <span>{{ $dataCheck(formatNumberMix(row.paymentCnt, 0, ','), '0') }}</span>
        </template>
        <template #paymentAmount="{ row }">
          <span>${{ $dataCheck(row.paymentAmount, '0') }}</span>
        </template>
        <template #orderCnt="{ row }">
          <span>{{ $dataCheck(row.orderCnt) }}</span>
        </template>
        <template #cpc="{ row }">
          <span>{{ $dataCheck(row.cpc) }}</span>
        </template>
        <template #cpm="{ row }">
          <span>{{ $dataCheck(row.cpm) }}</span>
        </template>
        <template #addToCartValue="{ row }">
          <span>{{ $dataCheck(formatNumberMix(row.addToCartValue, 2, ',')) }}</span>
        </template>
      </editor-header-table>
    </el-card>
    <editModal v-model="editVisable" :drawRow="drawRow" @save="reset"></editModal>
    <googleEditModal v-model="googleEditVisable" :drawRow="drawRow" @save="reset"></googleEditModal>
    <CardSetting
      v-model="showSetting"
      :list="cardSetting"
      :type="params.adSource"
      @onSave="changeCardSetting"
    ></CardSetting>
  </div>
</template>

<script>
import moment from 'moment'
import EditorHeaderTable from '@/components/editorHeader-table/main.vue'
import dataCard from './components/card'
import reportCard from '@/components/data-analysis/report'
import reportTable from '@/components/data-analysis/table'
import editModal from '@/views/marketing/components/edit-modal'
import googleEditModal from '@/views/marketing/components/google-modal'
import { setOverviewData, columns, fixTableHeaderList } from './staticData'
import { pickerOptions } from '@/utils/datepickerConfig'
import { getShopList, getErpShopList } from '@/server/shopList'
import { getMerchantType } from '@/server/user'
import {
  // getShopList,
  getAdAccountList,
  postAdData,
  getAdcostTop,
  getPayamountTop,
  getROITop,
  getCampaignTop,
  getMarketTrend,
  getAdTableDetail,
  getFbTrend,
  getFbTrans,
} from '@/server/etl'
import { getUserSetting } from '@/server/user'
import { formatNumberMix } from '@/utils'
import { TREND_LIST } from '@/config'
import setConfig from './mixinBoard.js'
import CardSetting from './components/cardSetting.vue'
import { CardKeyList, FbCardKeyList } from './staticData'
export default {
  components: { dataCard, editModal, googleEditModal, reportCard, reportTable, EditorHeaderTable, CardSetting },
  mixins: [setConfig],
  data() {
    return {
      popperOptions: {},
      reportHeight: '400px',
      editVisable: false,
      googleEditVisable: false,
      drawRow: {
        type: 'add',
        item: {},
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now()
        },
        ...pickerOptions,
      },
      fixTableHeaderList: fixTableHeaderList,
      columns: columns(0),
      defaultColumns: columns(0),
      date: [moment().subtract(29, 'days'), moment()],
      params: {
        startDate: moment().subtract(29, 'days').format('YYYY-MM-DD'),
        endDate: moment().format('YYYY-MM-DD'),
        adSource: 0,
        orgUnitId: this.$store.state.user.merchantId,
        // orgUnitId: 100,
        click_value: 'one_day_click',
        view_value: 'one_day_view',
        brandId: '',
      },
      form: {
        adAccountId: '', // 广告账户id
        adCampaignId: '', // 广告系列id
        adAdsetId: '', // 广告组id
        type: 2, // 1: 下钻，2: 选择框
      },
      loading: false,
      TableLoading: true,
      cardOptions: {},
      pagination: {
        pageNum: 1, // 页码
        pageSize: 20, // 每页大小
        total: 0,
      },
      tableName: 'bi-ads-all',
      measure1: 'cpc', // 指标1
      measure2: 'trans_rate', // 指标2
      shopList: [{ label: this.$t('system::common::select_all_shop'), value: '' }], // 店铺列表
      accounts: [], // 广告账户列表
      tableDataList: [],
      trendOptions: TREND_LIST,
      currentType: 1,
      currentRow: '',
      cardSetting: [...CardKeyList], // 卡片设置
      showSetting: false,
    }
  },
  computed: {
    sourceType() {
      return this.$store.state.user.sourceType
    },
  },
  async mounted() {
    this.cardOptions = setOverviewData({}, this.params, this.cardSetting)
    await this.getUserSetting()
    // 获取数据
    this.getInitData()
    this.getAllData()
  },
  methods: {
    moment,
    formatNumberMix,
    async getUserSetting() {
      const { data } = await getUserSetting(this.params.adSource)
      if (data.code === this.$code && data.data.config) {
        let arr = JSON.parse(data.data.config)
        let isSame = true
        // 判断缓存配置是否是默认配置
        if (arr.length === this.cardSetting.length) {
          arr.forEach(el => {
            if (!this.cardSetting.some(item => el.key === item.key && el.label === item.label)) {
              isSame = false
            }
          })
        } else {
          isSame = false
        }
        if (isSame) {
          this.cardSetting = arr
        }
      }
    },
    getInitData() {
      this.getShopList()
      this.getAdsAccountList()
    },
    // 修改tab来源
    async changeSource(type) {
      this.params.adSource = type
      if (type === 1) {
        this.cardSetting = [...FbCardKeyList]
      } else {
        this.cardSetting = [...CardKeyList]
      }
      await this.getUserSetting()
      this.reset()
    },
    // 配置谷歌或者fb账号弹窗
    async onSetAd(type) {
      if (type === 'fb') {
        this.editVisable = true
      } else if (type === 'google') {
        this.googleEditVisable = true
      }
    },
    // 获取当前页所有数据
    getAllData() {
      this.getOverviewData()
      if (this.params.adSource === 0) {
        this.getSalesEcharts()
        this.getAdcostTop()
        this.getPayamountTop()
        this.getROITop()
        this.getCampaignTop()
      }
      if (this.params.adSource === 1) {
        this.handleTransChange()
        this.getTrendData()
      }
      this.pagination.pageNum = 1
      this.getAdsTableData()
    },
    // 获取表格下钻后的值
    getTableSeries(row, type) {
      switch (type) {
        case 1:
          return row.adAccountName
        case 2:
          return row.adCampaignName
        case 3:
          return row.adAdsetName
        case 4:
          return row.adName
      }
    },
    // 设置表头名字
    getTableHeader() {
      switch (this.currentType) {
        case 1:
          return this.$t('ad-analysis::adAccount')
        case 2:
          return this.$t('ad-analysis::adSeries')
        case 3:
          return this.$t('ad-analysis::adGroup')
        case 4:
          return this.$t('ad-analysis::adName')
      }
    },
    // 表格下钻
    clickTableSeries(row, type) {
      this.currentRow = row
      this.currentType = type ? type : this.currentType + 1
      this.form.type = 1
      if (this.currentType === 1) {
        this.form.adAccountId = ''
        this.form.adCampaignId = ''
        this.form.adAdsetId = ''
      }
      if (this.currentType === 2) {
        this.form.adAccountId = row.adAccountId
        this.form.adCampaignId = ''
        this.form.adAdsetId = ''
      }
      if (this.currentType === 3) {
        this.form.adCampaignId = row.adCampaignId
        this.form.adAdsetId = ''
      }
      if (this.currentType === 4) {
        this.form.adAdsetId = row.adAdsetId
      }
      this.pagination.pageNum = 1
      this.getAdsTableData()
    },
    // 获取商家列表
    // async getShopList() {
    //   let params = { ...this.params }
    //   for (let key in params) {
    //     if (!params[key] && params[key] !== 0) delete params[key]
    //   }
    //   const { data } = await getShopList(params)
    //   if (data.code === this.$code && data.data) {
    //     this.shopList = [
    //       { label: this.$t('system::common::select_all_shop'), value: '' },
    //       ...data.data.datas.map(item => ({ label: item.brandName, value: item.brandId }))
    //     ]
    //   }
    // },
    async getShopList() {
      const res = await getMerchantType(this.$store.state.user.merchantId)
      if (res.data.code === this.$code) {
        if (res.data.data === 1) {
          const { data } = await getShopList({ pageSize: 10000, pageNum: 1 })
          if (data.code === this.$code) {
            this.shopList = [
              { label: this.$t('system::common::select_all_shop'), value: '' },
              ...((data.data && data.data.items) || []).map(el => ({
                label: el.shopName,
                value: el.shopId,
              })),
            ]
          }
        } else if (res.data.data === 2) {
          const { data } = await getErpShopList(this.$store.state.user.merchantId)
          if (data.code === this.$code) {
            this.shopList = [
              { label: this.$t('system::common::select_all_shop'), value: '' },
              ...(data.data || []).map(el => ({
                label: el.shopName,
                value: el.shopId,
              })),
            ]
          }
        }
      }
    },
    // 获取广告账号列表
    async getAdsAccountList() {
      let params = { ...this.params }
      for (let key in params) {
        if (!params[key] && params[key] !== 0) delete params[key]
      }
      const { data } = await getAdAccountList(params)
      if (data.code === this.$code) {
        this.accounts = data.data.datas.map(item => ({ label: item.accountName, value: item.accountId }))
      }
    },
    // 获取数据概览
    async getOverviewData() {
      this.loading = true
      let params = { ...this.params }
      for (let key in params) {
        if (!params[key] && params[key] !== 0) delete params[key]
      }
      const { data } = await postAdData(params)
      this.cardOptions = setOverviewData(
        data.code === this.$code ? data.data.datas[0] : {},
        this.params,
        this.cardSetting
      )
      this.loading = false
    },
    async getAdcostTop() {
      let params = { ...this.params }
      for (let key in params) {
        if (!params[key] && params[key] !== 0) delete params[key]
      }
      this.loadingSale.adCostTop = true
      const { data } = await getAdcostTop(params)
      this.adCostTop = this.setAdCostTop(data.code === this.$code ? data.data.datas : [], params)
      this.loadingSale.adCostTop = false
    },
    async getPayamountTop() {
      let params = { ...this.params }
      for (let key in params) {
        if (!params[key] && params[key] !== 0) delete params[key]
      }
      this.loadingSale.payamountTop = true
      const { data } = await getPayamountTop(params)
      this.payamountTop = this.setPayamountTop(data.code === this.$code ? data.data.datas : [], params)
      this.loadingSale.payamountTop = false
    },
    async getROITop() {
      let params = { ...this.params }
      for (let key in params) {
        if (!params[key] && params[key] !== 0) delete params[key]
      }
      this.loadingSale.roiTop = true
      const { data } = await getROITop(params)
      this.roiTop = this.setRoiTop(data.code === this.$code ? data.data.datas : [], params)
      this.loadingSale.roiTop = false
    },
    async getCampaignTop(demension) {
      let params = { ...this.params, demension: demension || 'ad_spend' }
      for (let key in params) {
        if (!params[key] && params[key] !== 0) delete params[key]
      }
      this.loadingSale.campaignTop = true
      const { data } = await getCampaignTop(params)
      this.campaignTop = this.setCampaignTop(data.code === this.$code ? data.data.datas : [], params)
      this.loadingSale.campaignTop = false
    },
    async getSalesEcharts() {
      let params = { ...this.params }
      for (let key in params) {
        if (!params[key] && params[key] !== 0) delete params[key]
      }
      this.loadingSale.salesEcharts = true
      const { data } = await getMarketTrend(params)
      this.salesEcharts = this.setSalesEcharts(data.code === this.$code ? data.data.datas : [], params)
      this.loadingSale.salesEcharts = false
    },
    async handleTransChange() {
      let params = { ...this.params }
      for (let key in params) {
        if (!params[key] && params[key] !== 0) delete params[key]
      }
      this.loadingSale.adTransData = true
      const { data } = await getFbTrans(params)
      this.adTransData = this.setTransData(data.code === this.$code ? data.data.datas : [], params)
      this.loadingSale.adTransData = false
    },
    async getTrendData() {
      if (!this.measure1 || !this.measure2) return
      let params = {
        measure1: this.measure1,
        measure2: this.measure2,
        ...this.params,
      }
      for (let key in params) {
        if (!params[key] && params[key] !== 0) delete params[key]
      }
      this.loadingSale.trendData = true
      const { data } = await getFbTrend(params)
      this.trendData = this.setTrendData(data.code === this.$code ? data.data.datas : [], params)
      this.loadingSale.trendData = false
    },
    handlerDateChange(date) {
      this.params.startDate = moment(date[0]).format('YYYY-MM-DD')
      this.params.endDate = moment(date[1]).format('YYYY-MM-DD')
      this.getAllData()
    },
    changeShop() {
      //       this.form = {
      //   adAccountId: '', // 广告账户id
      //   adCampaignId: '', // 广告系列id
      //   adAdsetId: '', // 广告组id
      //   type: 2 // 1: 下钻，2: 选择框
      // }
      // this.getAdsAccountList()
      // this.getAllData()
    },
    // 初始化
    reset() {
      this.pagination.pageNum = 1
      this.form = {
        adAccountId: '', // 广告账户id
        adCampaignId: '', // 广告系列id
        adAdsetId: '', // 广告组id
        type: 2, // 1: 下钻，2: 选择框
      }
      this.currentType = 1
      switch (this.params.adSource) {
        case 0:
          this.tableName = 'bi-ads-all'
          break
        case 1:
          this.tableName = 'bi-ads-fb'
          break
        case 2:
          this.tableName = 'bi-ad-google'
          break
      }
      this.columns = columns(this.params.adSource)
      this.defaultColumns = columns(this.params.adSource)
      this.params = {
        ...this.params,
        // startDate: moment()
        //   .subtract(29, 'days')
        //   .format('YYYY-MM-DD'),
        // endDate: moment().format('YYYY-MM-DD'),
        // click_value: 'one_day_click',
        // view_value: 'one_day_view',
        // brandId: ''
      }
      this.getAllData()
      this.getAdsAccountList()
    },
    async getAdsTableData() {
      this.TableLoading = true
      let params = {
        ...this.params,
        ...this.form,
        ...this.pagination,
      }
      for (let key in params) {
        if (!params[key] && params[key] !== 0) delete params[key]
      }
      const { data } = await getAdTableDetail(params)
      this.TableLoading = false
      if (data.code === this.$code) {
        this.tableDataList = data.data.datas
        this.pagination.total = data.data.totalSize || 0
      }
    },
    handleTableHeader() {
      this.$refs.editorTable.openDrawer()
    },
    ruleSetting() {
      this.showSetting = true
    },
    changeCardSetting(list) {
      this.cardSetting = [...list]
      this.getOverviewData()
      this.showSetting = false
    },
  },
}
</script>

<style lang="scss" scoped>
.ad-anaylsis-card {
  /deep/ .el-card__body {
    padding: 16px 6px;
  }
}
.data-page {
  color: $--color-text-primary;
  .card-content {
    margin-top: 10px;
  }
}
.select-group {
  // flex: 1;
  text-align: end;
  // padding: 10px 20px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  .select-type {
    width: 150px;
    margin: 0 10px;
  }
}
.table-search {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
}
.right-content {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  .select-item {
    width: 100px;
    margin: 0 10px;
  }
}
.setting {
  height: 113px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.trend-card {
  /deep/ .title {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}
</style>
